import React from 'react'

const EditNmotUserDialogContext = React.createContext()

export default EditNmotUserDialogContext